import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { getVariantPath } from '@uswitch/spark.utils';
import PropTypes from 'prop-types';
import React from 'react';
import { jsx as _jsx } from "theme-ui/jsx-runtime";
var wrapperVariantPath = getVariantPath({
  id: 'card',
  element: 'wrapper'
});
var topVariantPath = getVariantPath({
  id: 'card',
  element: 'top'
});
var bottomVariantPath = getVariantPath({
  id: 'card',
  element: 'bottom'
});
/**
 * A card is a container that can hold content, images and buttons.
 */

export var Card = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$as = _ref.as,
      As = _ref$as === void 0 ? 'div' : _ref$as,
      borderlessContent = _ref.borderlessContent,
      borderlessContentPosition = _ref.borderlessContentPosition,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["as", "borderlessContent", "borderlessContentPosition", "children"]);

  var divs = [children];

  if (borderlessContentPosition === 'top') {
    divs.unshift(_jsx("div", {
      sx: {
        variant: topVariantPath()
      },
      children: borderlessContent
    }, "borderless"));
  } else if (borderlessContentPosition === 'bottom') {
    divs.push(_jsx("div", {
      sx: {
        variant: bottomVariantPath()
      },
      children: borderlessContent
    }, "borderless"));
  }

  return _jsx(As, _objectSpread(_objectSpread({
    ref: ref,
    sx: {
      variant: wrapperVariantPath()
    }
  }, props), {}, {
    children: divs
  }));
});
Card.propTypes = {
  /**
   * Element to be displayed without padding or border, edge-to-edge
   */
  borderlessContent: PropTypes.element,

  /**
   * Whether to place the borderless element above or below the
   * card contents; default is top i.e. above the regular content
   */
  borderlessContentPosition: PropTypes.oneOf(['top', 'bottom'])
};
Card.defaultProps = {
  borderlessContentPosition: 'top'
};